var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeopleCircleFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 13.7002C6.52075 13.7002 4.77117 12.6868 3.74992 11.1668C3.77367 9.5835 6.91658 8.71266 8.49992 8.71266C10.0833 8.71266 13.2262 9.5835 13.2499 11.1668C12.2287 12.6868 10.4791 13.7002 8.49992 13.7002ZM8.49992 2.4585C9.12981 2.4585 9.7339 2.70872 10.1793 3.15412C10.6247 3.59952 10.8749 4.20361 10.8749 4.8335C10.8749 5.46339 10.6247 6.06748 10.1793 6.51287C9.7339 6.95827 9.12981 7.2085 8.49992 7.2085C7.87003 7.2085 7.26594 6.95827 6.82054 6.51287C6.37514 6.06748 6.12492 5.46339 6.12492 4.8335C6.12492 4.20361 6.37514 3.59952 6.82054 3.15412C7.26594 2.70872 7.87003 2.4585 8.49992 2.4585ZM8.49992 0.0834961C7.46029 0.0834961 6.43084 0.288267 5.47034 0.686116C4.50985 1.08397 3.63712 1.6671 2.90199 2.40223C1.41733 3.8869 0.583252 5.90053 0.583252 8.00016C0.583252 10.0998 1.41733 12.1134 2.90199 13.5981C3.63712 14.3332 4.50985 14.9164 5.47034 15.3142C6.43084 15.7121 7.46029 15.9168 8.49992 15.9168C10.5995 15.9168 12.6132 15.0828 14.0978 13.5981C15.5825 12.1134 16.4166 10.0998 16.4166 8.00016C16.4166 3.62225 12.8541 0.0834961 8.49992 0.0834961Z",
    fill: "black",
    fillOpacity: 0.66
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCircleFill);
export default __webpack_public_path__ + "static/media/PeopleCircleFill.99160310.svg";
export { ForwardRef as ReactComponent };